export default __webpack_public_path__ + "static/media/JorisIdeLogo.4e80d992.svg";